import React from "react";
import Header from "../component/Home/Header";
import Footer from "../component/Home/Footer";
import JobPortalCard from "../component/Job/JobCard";

const Jobs = () => {
  return (
    <>
      <Header />
      <JobPortalCard />
      <Footer />
    </>
  );
};

export default Jobs;
